import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input-error',
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss']
})
export class InputErrorComponent implements OnInit {
  @Input()
  control: FormControl;

  @Input()
  controlName: string;
  
  @Input()
  errorTranslatePrefix: string;

  errorPrefix: string;

  constructor(){
    this.errorPrefix = "ERRORS.";
  }

  ngOnInit() {
    if (this.errorTranslatePrefix !== undefined)
      this.errorPrefix = this.errorTranslatePrefix;
  }

  getFirstError(errors) {
    return this.errorIsPattern(errors) ? `${Object.keys(errors)[0]}_${this.controlName}` : Object.keys(errors)[0];
  }

  private errorIsPattern(errors: any) {
    return Object.keys(errors)[0] && Object.keys(errors)[0] === 'pattern' && this.controlName;
  }

  getErrorAdditionalInfo(errors) {
    if (errors.min && errors.min.min !== undefined) {
      return { min: errors.min.min };
    }
  }
}
